import './swiper';
import './accordion';
import './mobile-menu';


document.addEventListener('DOMContentLoaded', function () {


})